import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { isEmpty } from 'lodash';

import TextNavbar from './TextNavbar';
import ResponsivePlayer from '../../components/ResponsivePlayer';

import { ChildContainer } from './styles';

const { defaultVideoSource } = Meteor.settings.public;

const VideoPlayer = ({
  videoSource,
  videoTitle,
  videoTitleColor,
  videoTitleSize,
  videoTitleTextSize
}) => (
  <>
    {!isEmpty(videoTitle) && (
      <TextNavbar
        navbarColor={videoTitleColor}
        navbarHeight={videoTitleSize}
        navbarText={videoTitle}
        navbarTextSize={videoTitleTextSize}
      />
    )}
    <ChildContainer heightToRemove={isEmpty(videoTitle) ? '0px' : videoTitleSize}>
      <ResponsivePlayer fullSize url={videoSource} />
    </ChildContainer>
  </>
);

VideoPlayer.defaultProps = {
  videoSource: defaultVideoSource,
  videoTitle: '',
  videoTitleColor: 'black',
  videoTitleSize: '15px',
  videoTitleTextSize: '15px'
};

VideoPlayer.propTypes = {
  videoSource: PropTypes.string,
  videoTitle: PropTypes.string,
  videoTitleColor: PropTypes.string,
  videoTitleSize: PropTypes.string,
  videoTitleTextSize: PropTypes.string
};

export default VideoPlayer;
